import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword, getApiErrorMessage } from "../api";
import { useAuth } from "../context/AuthContext";

export default function Settings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("Новый пароль и подтверждение не совпадают");
      return;
    }

    setSubmitting(true);
    try {
      await changePassword(currentPassword, newPassword);
      setSuccess("Пароль изменён. Войдите с новым паролем.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      await logout();
      setTimeout(() => navigate("/login", { replace: true }), 1200);
    } catch (err) {
      setError(getApiErrorMessage(err, "Не удалось сменить пароль"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h2>Настройки</h2>
        <p className="page-subtitle">
          {user?.display_name || user?.username} · смена пароля
        </p>
      </div>

      <div className="settings-card">
        <h3>Сменить пароль</h3>
        <form className="settings-form" onSubmit={handleSubmit}>
          {error && <div className="login-error">{error}</div>}
          {success && <div className="settings-success">{success}</div>}

          <label className="login-label">
            Текущий пароль
            <input
              type="password"
              className="login-input"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
              required
              disabled={submitting}
            />
          </label>

          <label className="login-label">
            Новый пароль
            <input
              type="password"
              className="login-input"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
              disabled={submitting}
            />
          </label>

          <label className="login-label">
            Подтверждение нового пароля
            <input
              type="password"
              className="login-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
              disabled={submitting}
            />
          </label>

          <p className="settings-hint">Минимум 8 символов. После смены потребуется повторный вход.</p>

          <button type="submit" className="login-button" disabled={submitting}>
            {submitting ? "Сохранение..." : "Сохранить пароль"}
          </button>
        </form>
      </div>
    </div>
  );
}
